import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { hardNavigate, navigateTo } from '@presentation/shared/router';
import { CheckUserFeatureExistsUseCase } from 'app/core/usecases/user/check-user-feature-exists.usecase';
import { NEW_HOMEPAGE_URL, WEB_NEW_HOMEPAGE } from 'app/presentation/shared/constants';

@Injectable()
export class ShouldNavigateToOldHomepage implements CanActivate {
  constructor(private _checkUserFeatureExistsUseCase: CheckUserFeatureExistsUseCase) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const newHomepageEnabled = this._checkUserFeatureExistsUseCase.execute(WEB_NEW_HOMEPAGE);

    if (state.url === '/home' && !newHomepageEnabled) {
      navigateTo('/products');
    }

    if (newHomepageEnabled) {
      hardNavigate(NEW_HOMEPAGE_URL);

      return false;
    }

    return true;
  }
}
